var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDueWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.999756H6V2.33309H10V0.999756ZM7.33333 9.66642H8.66667V5.66642H7.33333V9.66642ZM12.6867 5.25976L13.6333 4.31309C13.3467 3.97309 13.0333 3.65309 12.6933 3.37309L11.7467 4.31976C10.6849 3.46521 9.36291 2.99944 8 2.99976C4.68667 2.99976 2 5.68642 2 8.99976C2 12.3131 4.68 14.9998 8 14.9998C9.12954 15.0004 10.2363 14.6819 11.1928 14.0811C12.1492 13.4802 12.9165 12.6214 13.4063 11.6036C13.8961 10.5857 14.0883 9.45027 13.961 8.32792C13.8337 7.20558 13.392 6.14203 12.6867 5.25976ZM8 13.6664C5.42 13.6664 3.33333 11.5798 3.33333 8.99976C3.33333 6.41976 5.42 4.33309 8 4.33309C10.58 4.33309 12.6667 6.41976 12.6667 8.99976C12.6667 11.5798 10.58 13.6664 8 13.6664Z",
    fill: "#212B36",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueWatch);
export default __webpack_public_path__ + "static/media/dueWatch.30f243751a6d9ec43cb58e131bb9387b.svg";
export { ForwardRef as ReactComponent };